import { render, staticRenderFns } from "./BaseGeneralData.vue?vue&type=template&id=1782bd4c&"
import script from "./BaseGeneralData.vue?vue&type=script&lang=js&"
export * from "./BaseGeneralData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports